<template>
  <AppWrapper>
    <template v-if="$route.meta.isDashboard">
      <DashboardWrapper v-if="healthDataLoaded">
        <Modal :open="openModal" notClosable :headline="headline" size="s">
          <LegalForm
            v-if="user.currentConsents"
            @accepted="closeModal"
            :legals="setLegalObject()"
          />
        </Modal>
        <router-view />
        <ContentSheet />
      </DashboardWrapper>
    </template>
    <template v-else>
      <NavBar v-if="!$route.meta.hideNavBar" :hideShadow="!navBarHasShadow" />
      <router-view />
      <Footer :isDashboard="$route.meta.isDashboard" />
      <ContentSheet />
    </template>
  </AppWrapper>
</template>

<script>
import AppWrapper from '@/components/AppWrapper';
import DashboardWrapper from '@/components/DashboardWrapper';
import NavBar from '@/components/NavBar';
import Footer from '@/components/Footer';
import ContentSheet from '@/components/ContentSheet';
import Modal from '@/components/Modal';
import LegalForm from '@/components/Forms/LegalForm';

import { mapFieldsUser, mapFieldsHealth } from '@/store/mapFields';
import Tracking from '@/helpers/tracking/Tracking';

import { setCid, setLandingPageReferrer, setReferrer } from '@/helpers/tracking/utils/helpers';

export default {
  name: 'App',
  components: {
    LegalForm,
    Modal,
    AppWrapper,
    NavBar,
    Footer,
    DashboardWrapper,
    ContentSheet,
  },
  watch: {
    $route: function () {
      this.navBarShadow();
    },
  },
  created() {
    this.navBarShadow();
    this.setBiTracking();
  },

  computed: {
    ...mapFieldsUser(['user']),
    ...mapFieldsHealth(['healthDataLoaded']),
  },
  updated() {
    this.setModal();
    this.trackURLChange();
  },

  data() {
    return {
      navBarHasShadow: false,
      openModal: false,
      headline: '',
    };
  },
  methods: {
    navBarShadow() {
      this.navBarHasShadow = !!this.$route.meta.navBarHasShadow;
    },
    setModal() {
      if (this.user.currentConsents) {
        this.openModal = !this.user.currentConsents.privacyStatement.isCurrent;

        this.setHeadline();
      }
    },
    setLegalObject() {
      if (this.user.currentConsents) {
        return {
          privacyStatement: this.user.currentConsents.privacyStatement,
        };
      }
    },
    setHeadline() {
      if (!this.user.currentConsents.privacyStatement.isCurrent) {
        this.headline =
          this.$t('profile.legal.form.headline') + this.$t('legalsform.privacyStatement');
      }
    },
    closeModal() {
      this.openModal = false;
    },
    setBiTracking() {
      setCid();
      setReferrer();
      setLandingPageReferrer();
    },
    trackURLChange() {
      if (
        !window.location.href.match(/wizard/) &&
        !window.location.href.match(/\/pflegegradrechner\/start\/2/)
      ) {
        Tracking.trackDatalayer({
          event: 'page_view',
          page_location: window.location.href,
        });
      }
    },
  },
};
</script>
